import {
  IComponent,
  IVideoComponent,
  IAlertBoxComponent,
  ICustomComponent,
  IComponentCss,
  IWebcamComponent,
  ISLWidgetComponent,
} from '@/helpers/editor';
import { Component, Prop } from 'vue-property-decorator';
import EditorBase from '../EditorBase';
import { EModalName } from '@/helpers/modal';

@Component({})
export default class TemplateMixin extends EditorBase {
  @Prop({ required: true })
  component: IComponent | IVideoComponent | IAlertBoxComponent | ICustomComponent | IWebcamComponent | ISLWidgetComponent;

  @Prop({ required: true })
  zIndex: number;

  @Prop({ default: false })
  isEditor: boolean;

  @Prop({ default: false })
  isPreview: boolean;

  @Prop({ default: false })
  isOverlayPreview: boolean;

  @Prop({ default: false })
  isFocused: boolean;

  @Prop({ default: null })
  uuid: string;

  @Prop({ default: null })
  sessionId: string;

  @Prop({ default: null })
  widgetToken: string;

  @Prop({ default: false })
  isSceneThumbnail: boolean;

  @Prop({ default: false })
  isVertical: boolean;

  get cssObject(): IComponentCss {
    const component = this.isVertical
      ? this.component.verticalSettings
      : this.component;

    const baseCss: IComponentCss = this.isEditor
      ? {
        width: component?.w,
        height: component?.h,
        top: component?.y,
        left: component?.x,
        zIndex: this.zIndex,
      }
      : {
        width: `${component?.w ?? 0}px`,
        height: `${component?.h ?? 0}px`,
        top: `${component?.y ?? 0}px`,
        left: `${component?.x ?? 0}px`,
        zIndex: this.zIndex,
      };

    if (!component?.css) return { ...baseCss, ...this.customCss };

    const componentCss = component.css;

    const extendedCss: IComponentCss = {
      ...baseCss,
      color: componentCss.color,
      fontSize: componentCss.fontSize ? `${componentCss.fontSize}px` : undefined,
      opacity: componentCss.opacity != null ? componentCss.opacity : undefined,
      lineHeight: componentCss.lineHeight,
      letterSpacing: componentCss.letterSpacing,
      fontFamily: componentCss.fontFamily,
      fontWeight: componentCss.fontWeight,
      fontStyle: componentCss.fontStyle,
      textAlign: componentCss.textAlign,
      textDecoration: componentCss.textDecoration,
      textShadow:
        componentCss.textShadowEnabled &&
          componentCss.textShadowOffset &&
          componentCss.textShadowColor
          ? `${componentCss.textShadowOffset} ${componentCss.textShadowColor}`
          : undefined,
      webkitTextStrokeColor:
        componentCss.textStrokeEnabled && componentCss.textStrokeColor
          ? componentCss.textStrokeColor
          : undefined,
      webkitTextStrokeWidth:
        componentCss.textStrokeEnabled && componentCss.textStrokeWidth
          ? `${componentCss.textStrokeWidth}px`
          : undefined,
      transform: componentCss.rotate ? `rotate(${componentCss.rotate}deg)` : undefined,
      border:
        componentCss.borderEnabled &&
          componentCss.borderColor &&
          componentCss.borderWidth
          ? `${componentCss.borderWidth}px solid ${componentCss.borderColor}`
          : undefined,
      borderRadius: componentCss.borderEnabled && componentCss.borderRadius
        ? `${componentCss.borderRadius}px`
        : undefined,
    };

    return { ...extendedCss, ...this.customCss };
  }

  get customCss() {
    return {};
  }

  get textReverseScale(): number {
    return 1 / this.scale;
  }

  get hasWidgetToken(): boolean {
    // userSLWidgetToken from editor
    // widgetToken from overlay
    return !!(this.userSLWidgetToken || this.widgetToken);
  }

  get shouldDisplayComponentTitle(): boolean {
    return this.hasWidgetToken && (this.isOverlayPreview || this.isEditor);
  }

  openConnectStreamlabs() {
    this.$modal.show(EModalName.connectStreamlabsModal);
  }
}
